<template>
  <div>
    <div v-if="message.whichShow == 1" class="success">
      <span>{{ $t("threeState.Finished") }}</span>
      <!-- <a-icon type="check"/> -->
      <img src="@/assets/img/facecourse/true.png" class="trueImg" />
    </div>
    <div v-else-if="message.whichShow == 2" class="fail">
      <span>{{ $t("threeState.Incomplete") }}</span>
    </div>
    <!-- <div v-else-if="message.whichShow == 3" class="limit">
      <span style="font-size:.24rem;line-height:.2rem;">仅剩</span>
      <br>
      <span style="position:relative;top:-.04rem;font-size:.24rem;"><i style="font-size:.28rem;">{{message.limitDays}}</i>天</span>
    </div>-->
    <!-- <div v-else-if="message.whichShow == 3" class="limit" v-html="showLimitDay(message.limitDays)"></div> -->
    <div
      v-else-if="message.whichShow == 3"
      class="limit"
      v-html="showLimitDay(message.limitDays)"
    ></div>
    <div v-else-if="message.whichShow == 4" class="fail">
      <span>{{ $t("threeState.Expired") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["message"],
  data() {
    return {};
  },
  methods: {
    showLimitDay(days) {
      if (
        days.toString().indexOf("天") > 0 ||
        days.toString().indexOf("day") > 0
      ) {
        var num = days.toString().replace(/[^0-9]/gi, "");
        return (
          "<span>" +
          this.$t("threeState.left") +
          "<br>" +
          num +
          this.$t("threeState.days") +
          "</span>"
        );
      } else {
        return (
          "<span>" +
          this.$t("threeState.left") +
          "<br>" +
          days +
          this.$t("threeState.days") +
          "</span>"
        );
      }
    },
  },
};
</script>

<style lang="less">
.success {
  position: relative;
  width: 0.8rem;
  height: 0.8rem;
  border: 0.02rem solid #4aa854;
  border-radius: 50%;
  font-size: 0.2rem;
  color: #4aa854;
  text-align: center;
  white-space: nowrap;
  span {
    display: block;
    margin-top: 0.24rem;
    line-height: 0.2rem;
  }
  .trueImg {
    position: absolute;
    margin-left: -0.12rem;
    margin-bottom: 0.06rem;
    left: 50%;
    bottom: 0;
    width: 0.24rem;
    height: 0.18rem;
  }
}

.fail {
  display: flex;
  justify-content: center;
  align-items: center;
  // word-break: break-all;

  width: 0.8rem;
  height: 0.8rem;
  // line-height: 0.8rem;
  border: 0.02rem solid #ecedee;
  border-radius: 50%;
  font-size: 0.2rem;
  color: #666666;
  text-align: center;
  background: #f7f8f9;
}

.limit {
  display: flex;
  justify-content: center;
  align-items: center;
  // word-break: break-all;
  white-space: nowrap;
  width: 0.8rem;
  height: 0.8rem;
  line-height: 1;
  border: 0.02rem solid #ee4040;
  border-radius: 50%;
  font-size: 0.2rem;
  color: #ee4040;
  text-align: center;
  background: #ffffff;
}

.over {
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
  border: 0.02rem solid #ecedee;
  border-radius: 50%;
  font-size: 0.2rem;
  color: #666666;
  text-align: center;
  background: #f7f8f9;
}
</style>
